import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlSerializer } from '@angular/router';

import {
  OnlyLoggedInUsersGuard,
  OnlyHasSecurityQuestionUsersGuard,
  OnlyHasParticipantIdUsersGuard,
  OnlyHasNoteIdRelationshipTypeUsersGuard,
  MaintenanceGuard
} from './services/user.service';

import {
  QP_OnlyLoggedInUsersGuard,
  QP_OnlyHasParticipantIdUsersGuard
} from './services/quickpay.service';

import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { LoginOneTimeComponent } from './components/login-one-time/login-one-time.component';
import { QuickPayComponent } from './components/quick-pay-login/quick-pay-login.component';
import { QuickPay_PaymentComponent } from './components/quick-pay-payment/quick-pay-payment.component'
import { ForgotUserNameComponent } from './components/forgot-user-name/forgot-user-name.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { UserRegistrationComponent } from './components/user-registration/user-registration.component';
import { MultifactorVerifyComponent } from './components/multifactor-verify/multifactor-verify.component';
import { UserSecurityQuestionComponent } from './components/user-security-question/user-security-question.component';

import { LoanDetailsComponent } from './components/loan-details/loan-details.component';

import { EsignDetailsComponent } from './components/esign-details/esign-details.component';
import { EsignNoteComponent } from './components/esign-note/esign-note.component';

import { PaymentNowComponent } from './components/payment-now/payment-now.component';
import { PaymentHistoryComponent } from './components/payment-history/payment-history.component';
import { PaymentAutomaticComponent } from './components/payment-automatic/payment-automatic.component';

import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { ContactInformationComponent } from './components/contact-information/contact-information.component';
import { FaqComponent } from './components/faq/faq.component';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { CaseInsensitiveUrlSerializer } from './UrlSerializer.module';

const routes: Routes = [
  {
    path: '',        // 10/25/2021 RA
    component: HomeComponent,
    canActivate: [MaintenanceGuard, OnlyLoggedInUsersGuard, OnlyHasSecurityQuestionUsersGuard, OnlyHasParticipantIdUsersGuard],
    data: {
      error: null
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [MaintenanceGuard],
    data: {
      error: null
    }
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent,
    data: {
      error: null
    }
  },
  {
    path: 'loginonetime',
    component: LoginOneTimeComponent,
    data: {
      error: null
    }
  },
  {
    path: 'forgotusername',
    component: ForgotUserNameComponent,
    data: {
      error: null
    }
  },
  {
    path: 'forgotpassword',
    component: ForgotPasswordComponent,
    data: {
      error: null
    }
  },
  {
    path: 'register',
    component: UserRegistrationComponent,
    data: {
      error: null
    }
  },
  {
    path: 'verify',
    component: MultifactorVerifyComponent,
    data: {
      error: null
    }
  },
  {
    path: 'securityquestion',
    component: UserSecurityQuestionComponent,
    canActivate: [OnlyLoggedInUsersGuard],
    data: {
      error: null
    }
  },
  {
    path: 'loandetails',
    component: LoanDetailsComponent,
    canActivate: [OnlyLoggedInUsersGuard, OnlyHasSecurityQuestionUsersGuard, OnlyHasParticipantIdUsersGuard],
    data: {
      error: null
    }
  },
  {
    path: 'esigndetails',
    component: EsignDetailsComponent,
    canActivate: [OnlyLoggedInUsersGuard, OnlyHasSecurityQuestionUsersGuard, OnlyHasParticipantIdUsersGuard],
    data: {
      error: null
    }
  },
  {
    path: 'esignnote',
    component: EsignNoteComponent,
    canActivate: [
      OnlyLoggedInUsersGuard,
      OnlyHasSecurityQuestionUsersGuard,
      OnlyHasParticipantIdUsersGuard,
      OnlyHasNoteIdRelationshipTypeUsersGuard
    ],
    data: {
      error: null
    }
  },
  {
    path: 'paynow',
    component: PaymentNowComponent,
    canActivate: [OnlyLoggedInUsersGuard, OnlyHasSecurityQuestionUsersGuard, OnlyHasParticipantIdUsersGuard],
    data: {
      error: null
    }
  },
  {
    path: 'payineligible',
    component: PaymentNowComponent,
    canActivate: [OnlyLoggedInUsersGuard, OnlyHasSecurityQuestionUsersGuard, OnlyHasParticipantIdUsersGuard],
    data: {
      error: null
    }
  },
  {
    path: 'transactionhistory',
    component: PaymentHistoryComponent,
    canActivate: [OnlyLoggedInUsersGuard, OnlyHasSecurityQuestionUsersGuard, OnlyHasParticipantIdUsersGuard],
    data: {
      error: null
    }
  },
  {
    path: 'autopay',
    component: PaymentAutomaticComponent,
    canActivate: [OnlyLoggedInUsersGuard, OnlyHasSecurityQuestionUsersGuard, OnlyHasParticipantIdUsersGuard],
    data: {
      error: null
    }
  },
  {
    path: 'contactus',
    component: ContactUsComponent,
    data: {
      error: null
    }
  },
  {
    path: 'quickpay',
    component: QuickPayComponent,
    canActivate: [MaintenanceGuard],
    data: {
      error: null
    }
  },
  {
    path: 'quickpay_pay',
    component: QuickPay_PaymentComponent,
    canActivate: [QP_OnlyLoggedInUsersGuard, QP_OnlyHasParticipantIdUsersGuard],
    data: {
      error: null
    }
  },
  {
    path: 'profile',
    component: ContactInformationComponent,
    canActivate: [OnlyLoggedInUsersGuard, OnlyHasSecurityQuestionUsersGuard, OnlyHasParticipantIdUsersGuard],
    data: {
      error: null
    }
  },
  {
    path: 'faq',
    component: FaqComponent,
    canActivate: [OnlyLoggedInUsersGuard, OnlyHasSecurityQuestionUsersGuard],
    data: {
      error: null
    }
  },
  {
    path: '**',
    component: LoginComponent,
    data: {
      error: null
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
  providers: [ { provide: UrlSerializer, useClass: CaseInsensitiveUrlSerializer }  ]
})
export class AppRoutingModule {}
